<template>
  <div class="btn-round-area">
    <PartsChromeLink :to="to" :external="external" class="btn-round">
      {{ label }}<span class="btn-round_arrow" aria-hidden="true"></span>
    </PartsChromeLink>
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの丸ボタン。支給トップでは5箇所すべて
 * `div.btn-round-area > a.btn-round > テキスト + span.btn-round_arrow` の同一構造で、
 * 修飾クラスや `button` 版は存在しない。
 *
 * 色・余白の差分は支給CSSが親セレクタで付ける（`.regular-faq .btn-round` は赤、
 * `.sec_home-voice .btn-round-area` は SP のみ余白増）。よって prop でのバリアントは持たせず、
 * `btn-round-area` もこのコンポーネントに含めたまま親セクションの下に置く。
 *
 * `btn-round_arrow` は空 span のCSS矢印。支給には無いが装飾なので `aria-hidden` を足す。
 */
type Props = {
  to: string;
  label: string;
  external?: boolean;
};
withDefaults(defineProps<Props>(), { external: false });
</script>
